import { render, staticRenderFns } from "./Statisctic.vue?vue&type=template&id=49803758&scoped=true&"
import script from "./Statisctic.vue?vue&type=script&lang=js&"
export * from "./Statisctic.vue?vue&type=script&lang=js&"
import style0 from "./Statisctic.vue?vue&type=style&index=0&id=49803758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49803758",
  null
  
)

export default component.exports